import ToggleConfig from '../../../config/ToggleConfig';

/**
 * Remove PII for event data (internalIP and machineName)
 */
export default function filterEventPII<
  T extends { internalIp?: string; machineName?: string; machineUser?: string }
>(data: T, toggle: ToggleConfig): T {
  // copy and delete
  const copy = { ...data };
  if (!toggle.internalIp) {
    delete copy.internalIp;
  }
  if (!toggle.machineName) {
    delete copy.machineName;
  }
  if (!toggle.machineUser) {
    delete copy.machineUser;
  }
  return copy;
}
